import axios from 'axios';

const dataApiUrl = '/api/find';
let accessToken = null;

// Function to get access token
export const getAccessToken = async () => {
    try {
        const response = await axios.post('/api/login', {
            email: 'dev-user',
            password: 'dev-secret',
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.data.token; 
    } catch (error) {
        throw new Error('Error fetching access token: ' + error.message);
    }
};

// Function to get Medium articles
export const getMediumArticles = async () => {
    try {
        if (!accessToken) {
            accessToken = await getAccessToken();
        }

        const response = await axios.post(dataApiUrl, {
            collection: "Medium",
            database: "Articles",
            dataSource: "Cluster0"
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
            },
        });

        const items = response.data.documents;
        if (!items.length) {
            throw new Error('No items found');
        }

        return items;

    } catch (error) {
        throw new Error('Error fetching items: ' + error.message);
    }
};
